<template>
    <app-layout title="Beheer">
        <template #header>
            <page-title title="Gefaalde webshop orders" />
        </template>

        <template #pageContent>
            <p>Wanneer we een order hebben ontvangen van een partner via de api, maar voor één of andere reden kon er geen webshop order worden aangemaakt,
                dan kunnen we die opnieuw proberen aanmaken via deze pagina.  De data uit de logs is te bekijken en we kunnen opnieuw een json uitsturen naar de webshop api (Woocommerce)
                om het order aan te maken.</p>
            <div class="flex justify-between w-1/2 mt-2">
                <TableSearch tableId="configuration-failed-webshop-orders" :values="failedWebshopOrders" class="w-1/2" placeholder="Zoeken"/>
            </div>

            <Table id="configuration-failed-webshop-orders" :values="failedWebshopOrders" class="w-1/2">
                <thead>
                    <Th id="reference">Referentie</th>
                    <Th id="request_type.type">Webshop</th>
                    <Th :sort="false" class="w-[105px]"></Th>
                </thead>
                <tbody>
                <tr v-for="(failedWebshopOrder, key) in state.sortedValues['configuration-failed-webshop-orders']" :key="failedWebshopOrder.id">
                    <Td>{{ failedWebshopOrder.reference }}</Td>
                    <Td>{{ failedWebshopOrder.request_type.type }}</Td>
                    <Td>
                        <Modal
                            buttonClass="show"
                            buttonSize="small"
                            buttonTitle="Bekijk log details"
                            @modalOpened="loadLog(failedWebshopOrder)"
                            ref="modalLog"
                        >
                            <div class="pt-4" v-if="loadingLog">
                                <i class="fas fa-spinner fa-pulse mr-1"></i> Even geduld, bezig met ophalen van log data.
                            </div>
                            <div
                                v-else-if="log && !loadingLog"
                            >
                                <TreeView :data="log" :options="{rootObjectKey: 'log', maxDepth: 1}"></TreeView>
                            </div>
                        </Modal>
                        <Button buttonClass="redo" size="small" title="Opnieuw verzenden" :loading="loadingRetry" @click="retryFailedWebshopOrder(failedWebshopOrder)" />
                        <Button buttonClass="delete" size="small" title="Verwijderen" @click="deleteFailedWebshopOrder(failedWebshopOrder)" />
                    </Td>
                </tr>
                </tbody>
            </Table>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'
import TableSearch from '@/Components/TableSearch.vue'
import Modal from '@/Components/Modal.vue'

import store from '@/store'
import { Inertia } from "@inertiajs/inertia"
import {TreeView} from "vue-json-tree-view/src";
import { ref } from 'vue'

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Table,
        Td,
        Th,
        TableSearch,
        TreeView,
        Modal,
    },
    props: [
        'failedWebshopOrders',
        'log',
    ],
    setup (props)
    {
        const modalLog = ref(null)
        let loadingLog = ref(false)
        let loadingRetry = ref(false)

        function loadLog(failedWebshopOrder)
        {
            loadingLog.value = true

            Inertia.reload({
                data: { failed_webshop_order_id: failedWebshopOrder.id },
                only: ['log'],
                onSuccess: () => {
                    loadingLog.value = false
                },
            });
        }

        function retryFailedWebshopOrder(failedWebshopOrder)
        {
            loadingRetry.value = true

            Inertia.get('/configuration/failed-webshop-orders/' + failedWebshopOrder.id + '/retry', {
                onSuccess: () => {
                    loadingRetry.value = false
                },
            })
        }

        function deleteFailedWebshopOrder(failedWebshopOrder)
        {
            if (!confirm('Bent u zeker dat u dit gefaald webshop order wil verwijderen?'))
                return

            Inertia.delete('/configuration/failed-webshop-orders/' + failedWebshopOrder.id + '/delete')
        }

        return {
            state: store.state,
            ...store,
            modalLog,
            loadingLog,
            loadLog,
            loadingRetry,
            retryFailedWebshopOrder,
            deleteFailedWebshopOrder,
        }
    },
}

</script>
